var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 4.15888C0.75 1.85895 2.67194 0 4.99672 0C7.32806 0 9.25 1.85895 9.25 4.15888C9.25 5.31785 8.8285 6.39382 8.13475 7.30579C7.3694 8.31176 6.42608 9.18823 5.36427 9.87621C5.12126 10.0352 4.90194 10.0472 4.63523 9.87621C3.56737 9.18823 2.62404 8.31176 1.86525 7.30579C1.17099 6.39382 0.75 5.31785 0.75 4.15888ZM3.59711 4.28837C3.59711 5.05885 4.22583 5.66483 4.99672 5.66483C5.76812 5.66483 6.40288 5.05885 6.40288 4.28837C6.40288 3.5239 5.76812 2.88842 4.99672 2.88842C4.22583 2.88842 3.59711 3.5239 3.59711 4.28837Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.7be2b90ae47a57359af4171970ffc838.svg";
export { ForwardRef as ReactComponent };